import React from 'react'
import { connect } from 'react-redux'
import Autosuggest from 'react-autosuggest';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import { findAll } from 'highlight-words-core'
import buscarUsuarioPorEmpresaNomeIdEmail from '../../actions/usuario/buscarUsuarioEmpresaPorParte'

const theme = {
  input: 'form-control form-control-lg campo-busca',
  suggestion: 'list-group-item truncate-dd-a',
  suggestionsList: 'p-0',
  suggestionHighlighted: 'bg-light',
  suggestionFocused: 'active'
};

let time = null;

const classeHighlight = 'font-weight-bold';

const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '');

const escapeRegexCharactersEmail = str => str.replace(/[*+?^${}()|[\]\\]/g, '');

const getValorSugestao = sugestao => `${sugestao.id}-${sugestao.nome}`;

const getValorSugestaoEmail = sugestao => `${sugestao.email}`;

const trataAcentuacao = (value) => {
  let expressao = value;

  const mapaAcentuacao = [
    {
      expressaoProcurar: /a/gi,
      expressaoSubstituir: '[\u0061\u00E1\u00E2\u00E3]'
    },
    {
      expressaoProcurar: /c/gi,
      expressaoSubstituir: '[\u0063\u00E7]'
    },
    {
      expressaoProcurar: /e/gi,
      expressaoSubstituir: '[\u0065\u00E9\u00EA]'
    },
    {
      expressaoProcurar: /i/gi,
      expressaoSubstituir: '[\u0069\u00ED]'
    },
    {
      expressaoProcurar: /o/gi,
      expressaoSubstituir: '[\u006F\u00F3\u00F4\u00F5]'
    },
    {
      expressaoProcurar: /u/gi,
      expressaoSubstituir: '[\u0075\u00FA]'
    },
  ];

  mapaAcentuacao.forEach((i) => {
    expressao = expressao.replace(i.expressaoProcurar, i.expressaoSubstituir)
  });

  return expressao;
}


const getSugestoes = (value, resultado) => {
  let escapedValue = escapeRegexCharacters(value.trim());

  const ehEmail = new RegExp('\\S+@\\S+\\.+|\\S+@', 'i').test(value)

  if(ehEmail) {
    escapedValue = escapeRegexCharactersEmail(value.trim());
  }

  if (escapedValue === '') {
    return [];
  }

  escapedValue = trataAcentuacao(escapedValue);

  const regex = new RegExp(`\\W*(${escapedValue})\\W*`, 'i');

  const getSugestao = ehEmail ? getValorSugestaoEmail : getValorSugestao;

  return resultado.filter(r => regex.test(getSugestao(r)))
};

const montaSugestaoComHighlight = (part, index) => {
  const classe = part.highlight ? classeHighlight : null;

  return (
    <span className={classe} key={index}>{part.text}</span>
  )
};

const exibeSugestao = (sugestao, { query }) => {
  const textoSugestao = `${sugestao.id} - ${sugestao.nome}`;

  const matches = findAll({
    searchWords: [trataAcentuacao(query)],
    textToHighlight: textoSugestao
  });
  const parts = matches.map((parte) => {
    const { end, highlight, start } = parte;
    const text = textoSugestao.substr(start, end - start);
    return {
      text,
      highlight
    }
  });

  return (
    <a
      key={sugestao.id}>{parts.map(montaSugestaoComHighlight)}
    </a>
  )
};

export class SelecaoUsuarioEmpresaAutoComplete extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      value: props.value !== null && props.value !== undefined && props.value.id && props.value.nome ? `${props.value.id}-${props.value.nome}` : '',
      sugestoes: []
    };
  }

  handleFocus = (event) => event.target.select();

  onSuggestionsFetchRequested = ({ value }) => {
    clearTimeout(time);
    time = setTimeout(() => {
      if (value.length > 3 || value.match('^[0-9]+$') != null) {
        this.props.buscarUsuarioPorEmpresaNomeIdEmail(value, this.props.empresaSelecionada.id)
          .then((resp) => {
            if (resp.payload.data) {
              this.setState({
                sugestoes: getSugestoes(value, resp.payload.data)
              });
            }
          })
      }
    }, 500);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      sugestoes: []
    });
    if(this.state.value == '' || this.state.value == null) {
        this.props.selecionarUsuario(null)
    }
  };

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  onSuggestionSelected (event, { suggestion }) {
    this.props.selecionarUsuario(suggestion);
    this.setState({
      value: `${suggestion.id} - ${suggestion.nome}`
    });
  }

  render () {
    const { value } = this.state;

    const inputProps = {
      placeholder: this.props.placeholder,
      id: this.props.id,
      value,
      onChange: this.onChange,
      onClick: this.handleFocus,
      disabled: this.props.disabled
    };


    return (
      <React.Fragment>
        <Autosuggest suggestions={this.state.sugestoes}
                     getSuggestionValue={getValorSugestao}
                     renderSuggestion={exibeSugestao}
                     onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                     onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                     onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                     inputProps={inputProps}
                     theme={theme}/>
            {this.props.value && this.props.value.id ? <button type="button" className="close ml-3" aria-label="Close" style={{ color: 'red' }}
                                          onClick={() => {
                                            this.props.selecionarUsuario(null)
                                            this.setState({ value: '' })
                                          }
                                          }>
          <i className="material-icons">
            &#xe5cd;
          </i>
        </button> : ''}
      </React.Fragment>


    )
  }
}


export const mapStateToProps = state => {
  return {
    changeFieldValue,
    empresaSelecionada: state.empresaSelecionada
  }};


export default connect(mapStateToProps,
  {
    buscarUsuarioPorEmpresaNomeIdEmail
  })(reduxForm({
  form: 'formPesquisaUsuarioDirecionado',
})(SelecaoUsuarioEmpresaAutoComplete))
